var map = {
	"./client_1.png": 458,
	"./client_10.png": 3184,
	"./client_11.png": 4361,
	"./client_12.png": 7298,
	"./client_13.png": 1515,
	"./client_14.png": 9860,
	"./client_15.png": 9805,
	"./client_2.png": 625,
	"./client_3.png": 2760,
	"./client_4.png": 7927,
	"./client_5.png": 9614,
	"./client_6.png": 6965,
	"./client_7.png": 7868,
	"./client_8.png": 5675,
	"./client_9.png": 7810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3656;